module.exports = __webpack_public_path__ + "static/img/badge-no-activity-scheduled.7c40c3b.svg";